import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.sidebar');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.sidebar/view.scss */
:host {
  display: block;
  height: 100%;
  min-height: 100%;
}

.workbench-shell {
  background: var(--wb-canvas, #f3f6f8);
}

.workbench-sidebar-frame {
  border-right: 1px solid rgba(16, 44, 58, 0.12);
  background: linear-gradient(180deg, #102c3a 0%, #153746 52%, #102c3a 100%);
  box-shadow: 12px 0 34px rgba(16, 44, 58, 0.12);
}

.workbench-main {
  padding-bottom: 5rem;
  background: radial-gradient(circle at 72% -12%, rgba(0, 106, 166, 0.05), transparent 28rem), var(--wb-canvas, #f3f6f8);
}

.workbench-mobile-menu {
  bottom: max(1.25rem, env(safe-area-inset-bottom));
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: #006aa6;
  box-shadow: 0 14px 34px rgba(0, 76, 119, 0.3);
}

.workbench-mobile-menu:hover {
  background: #005585;
}

@media (min-width: 1024px) {
  .workbench-main {
    padding-bottom: 0;
  }
}`],
})
export class LayoutSidebarComponent implements OnInit {
    private mobileNavigationReturnFocus: HTMLElement | null = null;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (this.service.status.navbar === undefined) {
            await this.service.status.toggle('navbar', true);
        }
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }

    public async openMobileNavigation(event?: Event) {
        const trigger = event?.currentTarget;
        this.mobileNavigationReturnFocus = trigger instanceof HTMLElement
            ? trigger
            : (document.activeElement instanceof HTMLElement ? document.activeElement : null);
        await this.service.status.toggle('navbar', false);
        setTimeout(() => {
            const drawer = document.getElementById('workbench-mobile-drawer');
            const closeButton = drawer?.querySelector<HTMLElement>('[data-drawer-close="true"]');
            (closeButton || drawer)?.focus();
        }, 0);
    }

    public async closeMobileNavigation() {
        await this.service.status.toggle('navbar', true);
        const target = this.mobileNavigationReturnFocus;
        this.mobileNavigationReturnFocus = null;
        setTimeout(() => target?.focus(), 0);
    }

    public onMobileNavigationKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            event.preventDefault();
            void this.closeMobileNavigation();
            return;
        }
        if (event.key !== 'Tab') return;

        const drawer = document.getElementById('workbench-mobile-drawer');
        if (!drawer) return;
        const focusable = Array.from(drawer.querySelectorAll<HTMLElement>(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter((element) => element.offsetParent !== null);
        if (focusable.length === 0) {
            event.preventDefault();
            drawer.focus();
            return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    }
}

export default LayoutSidebarComponent;